import { HisSearch } from './search/his-search';

export class HisSearchCriteriaSet {
    id: number;
    defaulttext: string; // Title
    configFile: string;
    context: string;
    flowName: string;
    standard: boolean;
    search: HisSearch;
    emptyOption: boolean;

    constructor(
        id?: number,
        defaulttext?: string,
        configFile?: string,
        context?: string,
        flowName?: string,
        standard?: boolean,
        search?: HisSearch,
        emptyOption?: boolean ) {

        this.id = id;
        this.defaulttext = defaulttext;
        this.configFile = configFile;
        this.context = context;
        this.flowName = flowName;
        this.standard = standard;
        this.search = search;
        this.emptyOption = emptyOption;
    }
}
